import { useEffect, useState } from "react";
import "./style.scss"
const Singapore = () => {
    useEffect(() => {
        document.title = 'Singapore Online 1v1 Chinese Language Tuition - Sinobus';
    }, [])
    const gtag_report_conversion = () => {
        window.open('https://wa.me/8618244943229?text=Know%20more%20about%20Chinese%20online%20course', "_blank");
    }
    return <div className="tiktok">
        <img className="imgDf" src="../assets/singapore/SGTT.jpg" alt="" onClick={() => { gtag_report_conversion() }} />
    </div>
}
export default Singapore;